import PARENT from '../types.js';

export default `${PARENT}/DISTRIBUTION`;
